import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RegionsList } from '../../../../components/admin-dashboard-component/Regions/regions-list/regions-list';

@Component({
  selector: 'app-list-of-regions',
  imports: [RegionsList],
  templateUrl: './list-of-regions.html',
  styleUrl: './list-of-regions.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListOfRegions {}
